const Services = () => {
  return (
    <section>
      <div className="container">
        <div className="row py-5">
          <div className="col-12">
            <h2 className="text-center">Our Services</h2>
            <div className="text-center">
              <p className="" style={{ maxWidth: "50%", margin: "0 auto" }}>
                At Warraich Traders, performance and service are vitally
                important. We deliver efficient, timely and competitively low
                priced service.
              </p>
              <p className="my-4" style={{ margin: "0 auto" }}>
                We don’t believe that quality has to suffer in order to receive
                a good price. Quality workmanship at a fair price is what we
                strive to provide. We have spent years building valuable
                relationships with loyal suppliers and subcontractors. Thus the
                volume discounts we receive are reflected in our low pricing.
                The diversity of our project base is a distinguishing feature of
                our company. We take pride in our experienced, knowledgeable,
                and dedicated staff, as well as, our ability to use innovated
                construction techniques to complete projects at a lower cost.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
